
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem5Grid extends Serenity.EntityGrid<PsAdvPromoItem5Row, any> {
        protected getColumnsKey() { return PsAdvPromoItem5Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem5Dialog; }
        protected getIdProperty() { return PsAdvPromoItem5Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem5Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem5Row.localTextPrefix; }
        protected getService() { return PsAdvPromoItem5Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}